import { render, staticRenderFns } from "./objection-request-info.vue?vue&type=template&id=29930f54&scoped=true&"
import script from "./objection-request-info.vue?vue&type=script&lang=js&"
export * from "./objection-request-info.vue?vue&type=script&lang=js&"
import style0 from "./objection-request-info.vue?vue&type=style&index=0&id=29930f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29930f54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
